import { Button } from '@mui/material';
import React from 'react'
import { useNavigate } from 'react-router-dom';

const DetailCell = (props) => {
    const { row } = props;
    const navigate = useNavigate();
    const handleUpdate = ()=>{
        navigate(`/patient-list/users/record_detail_form/${row.pf_id}`, {state: {formType: row.form_type, form_code: row.form_code}})
    }
  return (
    <Button size='small' onClick={()=>handleUpdate(row)} color="primary" sx={{fontSize: "10px", textWrap:"nowrap"}}>Details</Button>
  )
}

export default DetailCell